import DapDSButton from './button.component'

export * from './button.component'
export default DapDSButton

DapDSButton.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-button': DapDSButton
  }
}
